<details class="history card">
        <summary>変更履歴（最新{{ items.length }}件・最大100件）</summary>
        @if (!items.length) { <p>変更履歴はありません。</p> }
        @for (item of items; track item.id) {
          <div class="history-row"><div class="history-actor"><span>変更者</span><strong>{{ item.actor }}</strong></div><div>{{ historyLabel(item) }}@if (item.reason || item.actionType !== 'resume') { <p>理由：{{ item.reason || '本人による登録' }}</p> }</div><time>{{ historyTime(item.createdAt) }}</time></div>
          @for (archive of item.before?.retiredSessions || []; track $index) {
            <details class="retired-answers"><summary>旧日程 {{ historyTime(archive.session.start) }} の回答（{{ archive.answers.length }}人）</summary>
              <p class="hint">日程変更前の回答です。新日程の回答・集計には含めません。</p>
              @for (answer of archive.answers; track answer.operatorUserId) {
                <p>{{ answer.name }}：{{ answer.plannedStatus === 'attending' ? '出席予定' : answer.plannedStatus === 'absent' ? '欠席予定' : '未回答' }}</p>
              }
            </details>
          }
        }
      </details>
